import _ from 'lodash';
export const OAuthAuthenticationMethods = [
    'client_secret_basic',
    'client_secret_jwt',
    'client_secret_post',
    'none',
    'private_key_jwt'
];
export const OAuthRespKeysForForm = [
    'oauth2_sso_enabled',
    'oauth2_client_authentication_method',
    'oauth2_client_id',
    'oauth2_client_secret',
    'oauth2_scopes',
    'oauth2_authorization_uri',
    'oauth2_user_info_uri',
    'oauth2_token_uri',
    'oauth2_user_name_attribute_name',
    'oauth2_jwk_set_uri',
    'oauth2_user_info_authentication_method'
];
export const OAuthParamsKeys = OAuthRespKeysForForm.map(k => _.camelCase(k));
// 顺序不要变
export const OAuthRespKeysForStatic = [
    'oauth2_redirect_uri',
    'oauth2_client_name',
    'oauth2_registration_id'
];
export const OAuthRespLabelForStaticMap = {
    oauth2_redirect_uri: 'Redirect URL',
    oauth2_client_name: 'Client Name',
    oauth2_registration_id: 'Registration ID',
};
export function makeOAuthPartialForm(_info) {
    const res = {};
    OAuthRespKeysForForm.forEach((key, idx) => {
        res[OAuthParamsKeys[idx]] = _info[key] || '';
    });
    return {
        ...res,
        oauth2SsoEnabled: res?.oauth2SsoEnabled || false,
        oauth2ClientAuthenticationMethod: res?.oauth2ClientAuthenticationMethod || 'client_secret_basic',
        oauth2UserInfoAuthenticationMethod: res?.oauth2UserInfoAuthenticationMethod || '',
    };
}
export const userInfoMethods = ['query', 'header', 'form'];
export const formInputs = [
    { key: 'oauth2ClientId', label: 'Client ID', placeholder: '', rule: 'disableEmoji|required|max:200' },
    { key: 'oauth2ClientSecret', label: 'Client Secret', placeholder: '', rule: 'disableEmoji|required|max:200' },
    { key: 'oauth2Scopes', label: 'Scope', tip: 'tips.scope', placeholder: 'read:user', rule: 'disableEmoji|required|max:200' },
    { key: 'oauth2AuthorizationUri', label: 'Authorization URL', placeholder: 'https://XXXX/login/oauth/authorize', rule: 'required|url|max:200' },
    { key: 'oauth2TokenUri', label: 'Token URL', placeholder: 'https://XXXX/login/oauth/access_token', rule: 'required|url|max:200' },
    { key: 'oauth2UserInfoAuthenticationMethod', label: 'User Info Method', placeholder: '', rule: '', type: 'select' },
    { key: 'oauth2UserInfoUri', label: 'User Info URL', placeholder: 'https://api.XXXX/user', rule: 'required|url|max:200' },
    { key: 'oauth2UserNameAttributeName', label: 'User Name Attribute Name', tip: 'tips.user_name_attribute_name', placeholder: 'email', rule: 'required|disableEmoji|max:200' },
    { key: 'oauth2JwkSetUri', label: 'Jwk Set URL', placeholder: 'https://XXXX/oauth2/v1/keys', rule: 'url|max:200' }
];
const oauthLocale = {
    en: {
        grantType: 'Grant Type',
        grantType_value: 'Authorization Code',
        tips: {
            scope: 'e.g., read:user',
            user_name_attribute_name: 'Please input the KEY of email information in the user info interface.',
        },
    },
    cn: {
        grantType: '授权模式',
        grantType_value: '授权码',
        tips: {
            scope: '例子：read:user',
            user_name_attribute_name: '请填写用户信息的接口中，邮箱的KEY值。',
        },
    },
};
export function $otFactory(lang = 'en') {
    function $ot(key) {
        return _.get(oauthLocale, `${lang}.${key}`) || key;
    }
    return $ot;
}
